import { observable, computed, action } from 'mobx';
import { API_URL } from '../constants/constants';
import { NotificationStore } from './NotificationStore';
import { OrderType } from '../models/interfaces';
import { CompanyStore } from './CompanyStore';

export class OrderTypesStore {
  @observable
  public types: Array<OrderType>;
  public notificationStore: NotificationStore;
  public companyStore: CompanyStore;

  constructor(
    initial: Array<OrderType> = [],
    notificationStore: NotificationStore,
    companyStore: CompanyStore
  ) {
    this.types = initial;
    this.notificationStore = notificationStore;
    this.companyStore = companyStore;
  }

  @computed
  get orderTypes() {
    return this.types;
  }

  @action
  async getOrderTypes() {
    const token = localStorage.getItem('token');
    const company = this.companyStore.selectedCompany;
    const url = `${API_URL}/v1/order-types?company=${company}`;
    const payload = { type: 'getOrderTypes', company: company };

    const headers = new Headers();
    headers.append('Content-type', 'application/json');
    headers.append('X-CSRF-TOKEN', `${token}`);

    const data = await fetch(url, {
      headers: headers,
      method: 'GET',
      credentials: 'include',
    })
      .then((res) => {
        return res.json();
      })
      .catch((err) => {
        const error = {
          type: 'error',
          message: err.message + ': ottotyyppejä ei voitu hakea',
          seen: false,
        };

        this.notificationStore.addNotification(error);

        return { error: 'error' };
      });

    if (data.error) {
      // @TODO: show error
    } else if (data.status) {
      this.notificationStore.addNotification({
        type: 'error',
        message: 'Virhe taustajärjestelmässä: ' + data.errors.join(),
        seen: false,
      });
    } else {
      this.types = data.Logistico_Reasoncode;

      // Sanity check since if BC doesn't answer anything
      // this fails even with optional chaining.
      if (this.types) {
        this.types = this.types.sort((a, b) => {
          if (a.Description < b.Description) {
            return -1;
          }
          if (a.Description > b.Description) {
            return 1;
          }
          return 0;
        });
      }
    }
  }
}

export default OrderTypesStore;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/OrderTypesStore.ts